var React = require('react');

function AddimageIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(.58 -.46)"},[React.createElement("rect",{"width":"24","height":"24","y":".46","fill":"#262626","rx":"4","key":0}),React.createElement("path",{"fill":"#FFF","d":"M20.84 12.46c0 4.963-4.036 9-9 9-4.962 0-9-4.037-9-9s4.038-9 9-9c4.964 0 9 4.037 9 9z","key":1}),React.createElement("path",{"fill":"#262626","stroke":"#262626","d":"M15.044 11.926h-2.67V9.257a.534.534 0 0 0-1.067 0v2.67h-2.67a.534.534 0 0 0 0 1.067h2.67v2.669a.534.534 0 0 0 1.068 0v-2.67h2.669a.534.534 0 0 0 0-1.067z","key":2})]));
}

AddimageIcon.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24"};

module.exports = AddimageIcon;

AddimageIcon.default = AddimageIcon;
